import React from 'react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorMessage: '' };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, errorMessage: String(error?.message || error) };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary] Uncaught render error:', error, info?.componentStack);
    try {
      fetch(`${API}/client-errors`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          message: String(error?.message || error).slice(0, 2000),
          stack: String(error?.stack || '').slice(0, 4000),
          component_stack: String(info?.componentStack || '').slice(0, 4000),
          url: window.location.href,
          user_agent: navigator.userAgent,
        }),
        keepalive: true,
      }).catch(() => {});
    } catch (_) {
      // reporting must never throw
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="flex min-h-screen items-center justify-center p-6"
          style={{ background: '#0B1437' }}
          data-testid="error-boundary-screen"
        >
          <div className="w-full max-w-md rounded-2xl bg-white p-8 text-center shadow-2xl">
            <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-red-50">
              <svg className="h-7 w-7 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v4m0 4h.01M10.29 3.86l-8.4 14.55A1.75 1.75 0 003.4 21h17.2a1.75 1.75 0 001.51-2.59l-8.4-14.55a1.75 1.75 0 00-3.02 0z" />
              </svg>
            </div>
            <h1 className="text-xl font-bold text-slate-900">Something went wrong</h1>
            <p className="mt-2 text-sm text-slate-500">
              A part of the page hit an unexpected error. Your data is safe — reloading usually fixes it.
            </p>
            <div className="mt-6 flex flex-col gap-2">
              <button
                type="button"
                onClick={() => window.location.reload()}
                className="w-full rounded-xl bg-[#35B7E8] px-4 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-[#1F8FBE]"
                data-testid="error-boundary-reload-btn"
              >
                Reload page
              </button>
              <button
                type="button"
                onClick={() => { window.location.href = '/'; }}
                className="w-full rounded-xl border border-slate-200 px-4 py-2.5 text-sm font-semibold text-slate-700 transition-colors hover:bg-slate-50"
                data-testid="error-boundary-home-btn"
              >
                Back to Dashboard
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
